import { useMemo } from 'react';

import { PlansProduct, SubscribePlan } from '../../../../types';
import { OnetimePeriod, PlanTemplateType, SubscriptionPeriod } from '../types';
import { filterPlanProducts } from '../utils';

/**
 * 전달받은 props의 변경사항에 따라 자동으로 선택된 플랜 정보를 제공하는 hook
 * 만약 선택된 플랜 정보가 없을 경우, 첫 번째 플랜 정보를 제공합니다.
 * @param plans
 * @param planType
 * @param maxCcu
 * @param planTemplateType
 * @param subscriptionPeriod
 * @param onetimePeriod
 */
export const useAutoSelectedPlanInfo = ({
  plans,
  planType,
  maxCcu,
  planTemplateType,
  subscriptionPeriod,
  onetimePeriod,
}: {
  plans: PlansProduct;
  planType: Omit<SubscribePlan, 'free'>;
  maxCcu: number;
  planTemplateType: PlanTemplateType;
  subscriptionPeriod?: SubscriptionPeriod;
  onetimePeriod?: OnetimePeriod;
}) => {
  return useMemo(() => {
    const key = planType === 'pro' ? 'PRO' : 'BASIC';

    const planProducts = plans[key];

    return (
      filterPlanProducts({
        plans: planProducts,
        planTemplateType,
        maxCcu,
        subscriptionPeriod,
        onetimePeriod,
      }) || { ...planProducts[0] }
    );
  }, [
    plans,
    planType,
    maxCcu,
    planTemplateType,
    subscriptionPeriod,
    onetimePeriod,
  ]);
};
